module.exports = __webpack_public_path__ + "img/Card_heart_K.8465ab24.svg";